module.exports = {"yytx21":{"daobanList":[{"title":"1:是否房屋租赁变更登记备案","values":[{"name":"是","xuanzhong":1,"cailiaoList":[{"name":"1、房屋租赁合同（复印件或扫描件）","state":"必要"},{"name":"2、双方当事人身份证明（复印件或扫描件）","state":"必要"},{"name":"3、房屋所有权证书或者其他合法权属证明（复印件或扫描件）","state":"必要"},{"name":"4、委托书及同意出租证明","state":"非必要"}]},{"name":"否","xuanzhong":1,"cailiaoList":[{}]}]}]}}


//////////////////
// WEBPACK FOOTER
// ./static/js/situation/yytx21.json
// module id = 1319
// module chunks = 0